const storage = window.localStorage;

export function clear(key, clearAll = false) {
    if (clearAll) {
        storage.clear();
    } else {
        storage.removeItem(key);
    }
}